import imageMobile from '../../../../assets/images/mobile_rentings.png';
import React, { useEffect, useState } from 'react';
import {
    BoxedRow,
    Circle,
    IconChevronLeftRegular,
    IconTechServiceRegular,
    NavigationBar,
    skinVars,
    Text1,
    Text2,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getCatalogImage } from '../../../../services/ProductService';
import { Device } from '../../../../models/Devices';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import Stopper from '../../../../components/Stopper';
import { managementEnvironment } from '../../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import { useDevicesContext } from '../../../../context/devices-context/DevicesContext';

const Devices: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [images, setImages] = useState<string[]>([]);
    const { trackingScreenView } = new TrackingEvents();
    const promises: Promise<string>[] = [];
    const size = useWindowSize();
    const { devices, setDevice, resetDevice } = useDevicesContext();
    const homeDisabled = managementEnvironment().VITE_STOPPER_HOME_DISABLED;

    const getDeviceLiteral = (device: Device): string => {
        switch (device.deviceType) {
            case 'FREE_DEVICE':
                return t('freeDevice');
            case 'R2R_ESTRENA_SUPPORT':
                return t('deviceIncludedEstrena');
            case 'R2R_SUPPORT':
                return t('includeDevice');
            case 'R2R_ESTRENA':
                return t('deviceEstrena');
            default:
                return t('device');
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }

        devices.forEach((item) =>
            promises.push(
                getCatalogImage(item.imageId)
                    .then((response) => `data:image/jpg;base64,${response.data.content}`)
                    .catch(() => imageMobile),
            ),
        );
        Promise.all(promises).then((images) => setImages(images));
        resetDevice();
    }, []);

    const sendToNative = (url: string, selectedDevice?: Device) => {
        if (url === '/device-detail') {
            if (!selectedDevice) return;
            setDevice(selectedDevice);
            navigate(url);
        } else {
            if (url === 'https://o2online.es/reparacion/') {
                window.open(url, '_blank');
            } else {
                window.location.href = url;
            }
        }
    };

    return homeDisabled ? (
        <Stopper></Stopper>
    ) : (
        <>
            <div
                className='devices-header'
                style={{ borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : 'none' }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='devices-header-navigationBar'>
                            <NavigationBar
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('devices')}
                            />
                        </div>
                        <div className='devices-header-return'>
                            <div
                                className='devices-header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='devices-header-return-icon'>
                                    <IconChevronLeftRegular size={20} />
                                </div>
                                <Text2 medium>{t('returnResponsive')}</Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='devices-header-breadcrumbs'>
                    <ThemeVariant>
                        <BreadCrumbsWrapper
                            title={t('devicesSection')}
                            breadcrumbs={[{ title: t('breadcrumbsHome'), url: '/home' }]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='devices-content'>
                {devices?.length > 0 && (
                    <>
                        <div className='devices-content__title'>
                            <Text1 medium color={skinVars.colors.neutralMedium}>
                                {t('contentTitleDevicesList')}
                            </Text1>
                        </div>
                        <div className='devices-content__info'>
                            <div className='devices-content__info__rows'>
                                {devices.map((item, index) => (
                                    <div className='devices-content__info__rows__list' key={index}>
                                        <BoxedRow
                                            asset={<img src={images[index]} height='100' />}
                                            title={item.name}
                                            description={getDeviceLiteral(item)}
                                            onPress={() => {
                                                sendToNative('/device-detail', item);
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className='devices-content__info__repair'>
                                <div className='devices-content__info__repair-row'>
                                    <BoxedRow
                                        title={t('devicesBoxedRowTitle')}
                                        asset={
                                            <Circle backgroundColor={skinVars.colors.brandLow} size={40}>
                                                <IconTechServiceRegular color={skinVars.colors.brand} />
                                            </Circle>
                                        }
                                        description={t('devicesBoxedRowSubtitle')}
                                        onPress={() => {
                                            sendToNative('https://o2online.es/reparacion/');
                                        }}
                                    ></BoxedRow>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Devices;
